export default __webpack_public_path__ + "static/media/get-started-image.c9758d92.png";